import React from "react";
import { FormItem } from "@tiny/components";
import { SenderDetailsInput } from "../../../../../components/ConditionInputs";

interface SenderDetailsValueProps {
  prefixName: string;
  disabled?: boolean;
}

function SenderDetailsValue(props: SenderDetailsValueProps) {
  const { prefixName, disabled } = props;

  const name = `${prefixName}.value.value`;

  return (
    <FormItem
      name={name}
      rules={{
        required: {
          value: true,
          message: "Required field",
        },
      }}
      watchValue
    >
      <SenderDetailsInput disabled={disabled} />
    </FormItem>
  );
}

export default SenderDetailsValue;
export { SenderDetailsInput };
